<template>
  <div v-if="show" class="message">
    <div class="message-main">
      <div class="message-p24">
        <div class="message-head">
          <h3 class="message-head-title">
            {{ title }}
          </h3>
          <button @click="handleCancel" class="message-head-close">
            <i class="message-head-close-icon">×</i>
          </button>
        </div>
        <div class="message-content">
          <p class="message-content-text">
            <i v-if="effect === 'success'" class="fa fa-exclamation-circle message-content-text-icon message-content-text-icon-success"></i>
            <i v-if="effect === 'error'" class="fa fa-exclamation-circle message-content-text-icon message-content-text-icon-error"></i>
            <i v-if="effect === 'info'" class="fa fa-exclamation-circle message-content-text-icon message-content-text-icon-info"></i>
            {{ message }}
          </p>
        </div>
        <div class="message-foot">
          <button v-if="type === 'box'" @click="handleCancel" class="message-foot-button-plain message-mr10">
            取消
          </button>
          <button @click="handleClose" class="message-foot-button">
            确定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MessageAlert',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'notification'
    },
    effect: {
      type: String,
      default: 'success'
    },
    title: {
      type: String,
      default: '提示'
    },
    message: {
      type: String,
      required: true
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancel');
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    },
    handleClose() {
      this.$emit('close');
      this.$destroy();
      this.$el.parentNode.removeChild(this.$el);
    }
  }
}
</script>

<style scoped>
.message {
  background-color: rgb(0 0 0 / 0.5);
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  z-index: 100000;
  inset: 0;
}
.message-main {
  box-shadow: 0 0 #0000, 0 0 #0000, 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  background-color: rgb(255 255 255);
  border-radius: 0.5rem;
  max-width: 28rem;
  width: 100%;
  margin-left: 1rem;
  margin-right: 1rem;
}
.message-head {
  justify-content: space-between;
  align-items: center;
  display: flex;
  margin-bottom: 1rem;
}
.message-head-title {
  color: rgb(107 114 128);
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.75rem;
  align-items: center;
  display: flex;
  margin: 0;
}
.message-head-close {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  color: rgb(156 163 175);
  cursor: pointer;
  background-color: transparent;
  background-image: none;
  border: 0;
}
.message-head-close-icon {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.message-content {
  margin-bottom: 1.5rem;
}
.message-content-text-icon {
  margin-right: 0.25rem;
}
.message-content-text-icon-success {
  color: rgb(59 130 246);
}
.message-content-text-icon-error {
  color: rgb(241, 102, 84);
}
.message-content-text-icon-info {
  color: rgb(156 163 175);
}
.message-content-text {
  color: rgb(96 98 102);
  margin: 0;
}
.message-foot {
  justify-content: flex-end;
  display: flex;
}
.message-foot-button {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  color: rgb(255 255 255);
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
  background-color: #E53935;
  border-radius: 0.25rem;
  cursor: pointer;
  border-width: 0;
}
.message-foot-button-plain {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  color: rgb(156 163 175);
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
  background-color: rgb(255, 255, 255);
  border-width: 0;
  border-radius: 0.25rem;
  cursor: pointer;
}
.message-p24 {
  padding: 1.5rem;
}
.message-mr10 {
  margin-right: 0.625rem;
}
</style>
